module.exports = __webpack_public_path__ + "img/77400.59ec120e.jpg";